import CoreValues from './CoreValues'
import FullServiceSolutions from './FullServiceSolutions'
import Header from './Header'
import MissionAndVision from './MissionAndVision'
import TeamSuccess from './TeamSuccess'
import WhatWeDo from './WhatWeDo'

const index = () => {
  return (
    <div className='min-h-screen pt-24 px-6 py-12 text-center overflow-x-hidden'>
      <Header />
      <MissionAndVision />
      <CoreValues />
      <WhatWeDo />
      <FullServiceSolutions />
      <TeamSuccess />
    </div>
  )
}

export default index
